import React, { useContext } from "react";
import logo from "assets/img/logo.svg";
import { useTranslation } from "react-i18next";
import { Stepper } from "./Stepper";
import { useParams } from "react-router-dom";
import { PatientContext } from "contexts/PatientContext";
import cn from "classnames";

interface NewPatientSideBarProps {
  className: string;
}

export const NewPatientSideBar = ({ className }: NewPatientSideBarProps) => {
  const { t } = useTranslation();
  const { patientId } = useParams();
  //@ts-ignore
  const { patient } = useContext(PatientContext);

  return (
    <div className={cn("pl-24 pr-10 py-12 bg-white", className)}>
      <div className="flex flex-col">
        <img src={logo} className="w-48" alt="oncoprecision logo" />
        <div className="py-16">
          <h2 className="text-3xl text-black">
            {patientId ? <>{t("patient")}</> : t("newPatient")}
          </h2>
          {patientId && (
            <h2 className="text-3xl text-black">
              <span className="inline-block align-middle truncate max-w-[300px] overflow-hidden text-ellipsis whitespace-nowrap text-gray-700">
                {patient?.identification}
              </span>
            </h2>
          )}
        </div>
        <Stepper />
      </div>
    </div>
  );
};
